import { createAction } from 'typesafe-actions';

export const setAppPages = createAction('projects/SET_APP_PAGES', resolve =>
  (pages: any) => resolve(pages)
);
